/*
 * The organiser's hub: one tab, every tool behind it.
 *
 * The staff tab bar had reached seven at 375px, and every new organiser screen was
 * either an eighth tab or a link buried at the bottom of Settings. This is the one
 * place they all live now: a list with one line each, nothing more than two taps
 * from the bar. Stewards never see it - their tree does not mount it.
 */
import { useNavigate } from 'react-router'
import {
  Award, CalendarCog, ChartColumn, ChevronRight, Hotel, Lightbulb, Megaphone,
  SlidersHorizontal, UsersRound,
} from 'lucide-react'
import { useSession } from '../lib/session'
import { EVENT } from '../config/event'
import { Masthead } from '../ui/Chrome'

const ICON = { size: 19, strokeWidth: 1.6 }

export function ManageRoute() {
  const navigate = useNavigate()
  const { isSuperAdmin } = useSession()

  const groups: Array<{ label: string; items: Array<{ to: string; title: string; sub: string; icon: React.ReactNode }> }> = [
    {
      label: 'On the day',
      items: [
        { to: '/admin/announcements', title: 'Announcements', sub: 'A line at the top of every delegate’s Home', icon: <Megaphone {...ICON} /> },
        { to: '/admin/attendance', title: 'Attendance report', sub: 'Who came to each session, export to Excel', icon: <ChartColumn {...ICON} /> },
        { to: '/admin/ideas', title: 'CLiS - Bank Ideas', sub: 'Approve posts, mark planned or done, show the wall', icon: <Lightbulb {...ICON} /> },
      ],
    },
    {
      label: 'Set up',
      items: [
        { to: '/venue/settings', title: 'Settings', sub: 'Certificate release, threshold, name lock, sound check-in', icon: <SlidersHorizontal {...ICON} /> },
        { to: '/admin/accommodation', title: 'Rooms', sub: 'Hotel roster and room numbers', icon: <Hotel {...ICON} /> },
        { to: '/admin/certificate', title: 'Certificates', sub: 'Template, name position, generate the PDFs', icon: <Award {...ICON} /> },
        { to: '/admin/event', title: 'Events and rooms', sub: 'Dates, and the rooms sessions can be held in', icon: <CalendarCog {...ICON} /> },
        ...(isSuperAdmin ? [
          { to: '/admin/users', title: 'Users', sub: 'Staff accounts and roles', icon: <UsersRound {...ICON} /> },
        ] : []),
      ],
    },
  ]

  return (
    <main className="page">
      <Masthead kicker={EVENT.shortName} title="Manage" />
      {groups.map((g) => (
        <section key={g.label} className="manage__group">
          <p className="kicker manage__label">{g.label}</p>
          <div className="manage__list">
            {g.items.map((item) => (
              <button key={item.to} type="button" className="manage__row" onClick={() => void navigate(item.to)}>
                <span className="manage__icon" aria-hidden="true">{item.icon}</span>
                <span className="manage__copy">
                  <strong>{item.title}</strong>
                  <span>{item.sub}</span>
                </span>
                <ChevronRight size={18} strokeWidth={1.6} className="manage__go" />
              </button>
            ))}
          </div>
        </section>
      ))}
    </main>
  )
}
